import { defineStore } from 'pinia'
import type { SegmentNoGroupCollection } from '@ve-pro/types/track.type'
import type { Diff } from 'deep-diff'
import { useTrackStore } from '../tracks'
import { cloneDeep } from 'lodash-es'
import { diff, applyChange, revertChange } from 'deep-diff'

import { defineSegmentProperties } from '../tracks/resolve-segment'

import { getGroupBySegment } from '../tracks/segment/segment-group'
import { SegmentType } from '@ve-pro/enums/segment'
import { VideoEventter } from '@ve-pro/ve/utils/event-bus'

type ValueDiff = Diff<{ value: SegmentNoGroupCollection | null }>[]

// 上一次保存的备份值(初始化时候一定要调用save)
let copied = null as SegmentNoGroupCollection | null

export const useSegmentHistoryStore = defineStore('segment-history', {
  state: () => {
    return {
      // 最大记录数
      max: 20,
      // 历史记录
      history: [] as ValueDiff[],
      // 可还原的历史记录
      poped: [] as ValueDiff[],
    }
  },
  actions: {
    init() {
      this.save()

      this.history = []
      this.poped = []
    },
    save() {
      const trackStore = useTrackStore()

      if (trackStore.activeChildSegment) {
        copied = cloneDeep(trackStore.activeChildSegment)
      } else {
        console.error(
          `trackStore.activeChildSegment is ${trackStore.activeChildSegment}`,
        )
      }
    },

    push() {
      const trackStore = useTrackStore()
      const value = trackStore.activeChildSegment
      const change = diff({ value: copied }, { value: cloneDeep(value) })
      if (change) {
        this.save()
        this.poped = []
        this.history.push(change)
        if (this.history.length > this.max) {
          this.history.shift()
        }
      }
    },

    undo() {
      const trackStore = useTrackStore()
      const change = this.history.pop()
      if (change) {
        this.poped.push(change)
        const cloned = cloneDeep(trackStore.activeChildSegment)
        change.forEach((item) => {
          revertChange({ value: cloned }, { value: copied }, item)
        })

        updateActiveSegmentChild(cloned)

        copied = cloneDeep(cloned)
      }
    },

    redo() {
      const trackStore = useTrackStore()
      const change = this.poped.pop()
      if (change) {
        this.history.push(change)
        const cloned = cloneDeep(trackStore.activeChildSegment)
        change.forEach((item) => {
          applyChange({ value: cloned }, { value: copied }, item)
        })

        updateActiveSegmentChild(cloned)

        copied = cloneDeep(trackStore.activeChildSegment)
      }
    },

    /**
     * 恢复到最新保存的状态
     */
    revert() {
      // const trackStore = useTrackStore()
      // trackStore.tracks = defineAllSegmentProperties(cloneDeep(copiedTracks))
      // updateTransitionRelevance()
      // updateMainTrack()
      // syncActiveSegment()
    },
    /**
     * 清空历史记录
     */
    clear() {
      this.history = []
      this.poped = []
    },
  },
})

function updateActiveSegmentChild(segment: SegmentNoGroupCollection | null) {
  const trackStore = useTrackStore()

  if (segment) {
    const result = defineSegmentProperties(segment, segment.source_rate)

    const groupSegment = getGroupBySegment(result)
    const children =
      (groupSegment && trackStore.segmentGroups[groupSegment.id]) || []

    const index = children.findIndex((item) => item.id === segment.id)

    if (index > -1) {
      children.splice(index, 1, result)

      if (result.type === SegmentType.Text) {
        VideoEventter.emit('textChange', [result])
      }
    }
  }
}
